// src/pages/About.jsx
import Layout from "../layouts/Layout";

import Breadcrumb from "../components/Breadcrumb";
import CounterSection from "../components/About/CounterSection";
import AboutSection from "../components/AboutSection";
import TeamSection from "../components/TeamSection";
import TestimonialSection from "../components/About/TestimonialSection";
import BrandSection from "../components/BrandSection";
import ServiceSection from "../components/ServiceSection";
import PortfolioSection from "../components/PortfolioSection";

const About = () => (
  <Layout>
    <Breadcrumb
      title="Về chúng tôi"
      parent={{ name: "Trang chủ", path: "/" }}
    />

    <AboutSection />
    <CounterSection />
    <ServiceSection />
    <BrandSection />
    <PortfolioSection />

    <TeamSection />
    <TestimonialSection />
  </Layout>
);

export default About;
